export default __webpack_public_path__ + "static/media/2526 cutlery top.26737fbd.png";